/*
 * Default Styles Package
 * This package defines a shared CSS styles template that can be used
 * by both Polymer and Lit-based components.
 */

export const defaultStyles = `
    /* THIS FILE IS BUILT FROM CSS IN [https://code.communitybuildar.com/community-buildar/cbar-design-tokens] */
    :host{
      /* ELEVATION.JS TOKENS */
      /* Surface tint color */
      --cbar-sys-elevation-surface-tint-color: var(--cbar-sys-color-primary);
      /* +5 */
      --cbar-sys-elevation-level5-value: 12px;
      --cbar-sys-elevation-level5-unit: 1px;
      --cbar-sys-elevation-level5: 12px;
      /* +4 */
      --cbar-sys-elevation-level4-value: 8px;
      --cbar-sys-elevation-level4-unit: 1px;
      --cbar-sys-elevation-level4: 8px;
      /* +3 */
      --cbar-sys-elevation-level3-value: 6px;
      --cbar-sys-elevation-level3-unit: 1px;
      --cbar-sys-elevation-level3: 6px;
      /* +2 */
      --cbar-sys-elevation-level2-value: 3px;
      --cbar-sys-elevation-level2-unit: 1px;
      --cbar-sys-elevation-level2: 3px;
      /* +1 */
      --cbar-sys-elevation-level1-value: 1px;
      --cbar-sys-elevation-level1-unit: 1px;
      --cbar-sys-elevation-level1: 1px;
      /* 0 */
      --cbar-sys-elevation-level0-value: 0px;
      --cbar-sys-elevation-level0-unit: 1px;
      --cbar-sys-elevation-level0: 0px;
      
      /* MOTION.CSS TOKENS */
      /* Emphasized decelerate easing (out) */
      --cbar-sys-motion-easing-emphasized-decelerate-x0: 0.05000000074505806;
      --cbar-sys-motion-easing-emphasized-decelerate-y0: 0.699999988079071;
      --cbar-sys-motion-easing-emphasized-decelerate-x1: 0.10000000149011612;
      --cbar-sys-motion-easing-emphasized-decelerate-y1: 1;
      /* Emphasized accelerate easing (in) */
      --cbar-sys-motion-easing-emphasized-accelerate-x0: 0.30000001192092896;
      --cbar-sys-motion-easing-emphasized-accelerate-y0: 0;
      --cbar-sys-motion-easing-emphasized-accelerate-x1: 0.800000011920929;
      --cbar-sys-motion-easing-emphasized-accelerate-y1: 0.15000000596046448;
      /* Standard decelerate easing (out) */
      --cbar-sys-motion-easing-standard-decelerate-x0: 0;
      --cbar-sys-motion-easing-standard-decelerate-y0: 0;
      --cbar-sys-motion-easing-standard-decelerate-x1: 0;
      --cbar-sys-motion-easing-standard-decelerate-y1: 1;
      /* Standard accelerate easing (in) */
      --cbar-sys-motion-easing-standard-accelerate-x0: 0.30000001192092896;
      --cbar-sys-motion-easing-standard-accelerate-y0: 0;
      --cbar-sys-motion-easing-standard-accelerate-x1: 1;
      --cbar-sys-motion-easing-standard-accelerate-y1: 1;
      /* Duration 1000ms */
      --cbar-sys-motion-duration-1000: 1000ms;
      /* Duration 900ms */
      --cbar-sys-motion-duration-900: 900ms;
      /* Duration 800ms */
      --cbar-sys-motion-duration-800: 800ms;
      /* Duration 700ms */
      --cbar-sys-motion-duration-700: 700ms;
      /* Duration 600ms */
      --cbar-sys-motion-duration-600: 600ms;
      /* Duration 550ms */
      --cbar-sys-motion-duration-550: 550ms;
      /* Duration 500ms */
      --cbar-sys-motion-duration-500: 500ms;
      /* Duration 450ms */
      --cbar-sys-motion-duration-450: 450ms;
      /* Duration 400ms */
      --cbar-sys-motion-duration-400: 400ms;
      /* Duration 350ms */
      --cbar-sys-motion-duration-350: 350ms;
      /* Duration 300ms */
      --cbar-sys-motion-duration-300: 300ms;
      /* Duration 250ms */
      --cbar-sys-motion-duration-250: 250ms;
      /* Duration 200ms */
      --cbar-sys-motion-duration-200: 200ms;
      /* Duration 150ms */
      --cbar-sys-motion-duration-150: 150ms;
      /* Duration 100ms */
      --cbar-sys-motion-duration-100: 100ms;
      /* Duration 50ms */
      --cbar-sys-motion-duration-50: 50ms;
      /* Standard easing (in and out) */
      --cbar-sys-motion-easing-standard-x0: 0.20000000298023224;
      --cbar-sys-motion-easing-standard-y0: 0;
      --cbar-sys-motion-easing-standard-x1: 0;
      --cbar-sys-motion-easing-standard-y1: 1;
      /* Linear easing */
      --cbar-sys-motion-easing-linear-x0: 0;
      --cbar-sys-motion-easing-linear-y0: 0;
      --cbar-sys-motion-easing-linear-x1: 1;
      --cbar-sys-motion-easing-linear-y1: 1;
      /* Emphasized */
      --cbar-sys-motion-easing-emphasized-x0: 0.20000000298023224;
      --cbar-sys-motion-easing-emphasized-y0: 0;
      --cbar-sys-motion-easing-emphasized-x1: 0;
      --cbar-sys-motion-easing-emphasized-y1: 1;
      /* Motion path */
      --cbar-sys-motion-path-standard-path: 1;

      /* PALETTE.CSS TOKENS */
      /* Error 0 */
      --cbar-ref-palette-error0: #000000ff;
      /* Error 10 */
      --cbar-ref-palette-error10: #410e0bff;
      /* Error 20 */
      --cbar-ref-palette-error20: #601410ff;
      /* Error 30 */
      --cbar-ref-palette-error30: #8c1d18ff;
      /* Error 40 */
      --cbar-ref-palette-error40: #b3261eff;
      /* Error 50 */
      --cbar-ref-palette-error50: #dc362eff;
      /* Error 60 */
      --cbar-ref-palette-error60: #e46962ff;
      /* Error 70 */
      --cbar-ref-palette-error70: #ec928eff;
      /* Error 80 */
      --cbar-ref-palette-error80: #f2b8b5ff;
      /* Error 90 */
      --cbar-ref-palette-error90: #f9dedcff;
      /* Error 95 */
      --cbar-ref-palette-error95: #fceeeeff;
      /* Error 99 */
      --cbar-ref-palette-error99: #fffbf9ff;
      /* Error 100 */
      --cbar-ref-palette-error100: #ffffffff;
      /* Tertiary 0 */
      --cbar-ref-palette-tertiary0: #000000ff;
      /* Tertiary 10 */
      --cbar-ref-palette-tertiary10: #31111dff;
      /* Tertiary 20 */
      --cbar-ref-palette-tertiary20: #492532ff;
      /* Tertiary 30 */
      --cbar-ref-palette-tertiary30: #633b48ff;
      /* Tertiary 40 */
      --cbar-ref-palette-tertiary40: #7d5260ff;
      /* Tertiary 50 */
      --cbar-ref-palette-tertiary50: #986977ff;
      /* Tertiary 60 */
      --cbar-ref-palette-tertiary60: #b58392ff;
      /* Tertiary 70 */
      --cbar-ref-palette-tertiary70: #d29dacff;
      /* Tertiary 80 */
      --cbar-ref-palette-tertiary80: #efb8c8ff;
      /* Tertiary 90 */
      --cbar-ref-palette-tertiary90: #ffd8e4ff;
      /* Tertiary 95 */
      --cbar-ref-palette-tertiary95: #ffecf1ff;
      /* Tertiary 99 */
      --cbar-ref-palette-tertiary99: #fffbfaff;
      /* Tertiary 100 */
      --cbar-ref-palette-tertiary100: #ffffffff;
      /* Secondary 0 */
      --cbar-ref-palette-secondary0: #000000ff;
      /* Secondary 10 */
      --cbar-ref-palette-secondary10: #1d192bff;
      /* Secondary 20 */
      --cbar-ref-palette-secondary20: #332d41ff;
      /* Secondary 30 */
      --cbar-ref-palette-secondary30: #4a4458ff;
      /* Secondary 40 */
      --cbar-ref-palette-secondary40: #625b71ff;
      /* Secondary 50 */
      --cbar-ref-palette-secondary50: #7a7289ff;
      /* Secondary 60 */
      --cbar-ref-palette-secondary60: #958da5ff;
      /* Secondary 70 */
      --cbar-ref-palette-secondary70: #b0a7c0ff;
      /* Secondary 80 */
      --cbar-ref-palette-secondary80: #ccc2dcff;
      /* Secondary 90 */
      --cbar-ref-palette-secondary90: #e8def8ff;
      /* Secondary 95 */
      --cbar-ref-palette-secondary95: #f6edffff;
      /* Secondary 99 */
      --cbar-ref-palette-secondary99: #fffbfeff;
      /* Secondary 100 */
      --cbar-ref-palette-secondary100: #ffffffff;
      /* Primary 0 */
      --cbar-ref-palette-primary0: #000000ff;
      /* Primary 10 */
      --cbar-ref-palette-primary10: #21005dff;
      /* Primary 20 */
      --cbar-ref-palette-primary20: #381e72ff;
      /* Primary 30 */
      --cbar-ref-palette-primary30: #4f378bff;
      /* Primary 40 */
      --cbar-ref-palette-primary40: #6750a4ff;
      /* Primary 50 */
      --cbar-ref-palette-primary50: #7f67beff;
      /* Primary 60 */
      --cbar-ref-palette-primary60: #9a82dbff;
      /* Primary 70 */
      --cbar-ref-palette-primary70: #b69df8ff;
      /* Primary 80 */
      --cbar-ref-palette-primary80: #d0bcffff;
      /* Primary 90 */
      --cbar-ref-palette-primary90: #eaddffff;
      /* Primary 95 */
      --cbar-ref-palette-primary95: #f6edffff;
      /* Primary 99 */
      --cbar-ref-palette-primary99: #fffbfeff;
      /* Primary 100 */
      --cbar-ref-palette-primary100: #ffffffff;
      /* Neutral Variant 0 */
      --cbar-ref-palette-neutral-variant0: #000000ff;
      /* Neutral Variant 10 */
      --cbar-ref-palette-neutral-variant10: #1d1a22ff;
      /* Neutral Variant 20 */
      --cbar-ref-palette-neutral-variant20: #322f37ff;
      /* Neutral Variant 30 */
      --cbar-ref-palette-neutral-variant30: #49454fff;
      /* Neutral Variant 40 */
      --cbar-ref-palette-neutral-variant40: #605d66ff;
      /* Neutral Variant 50 */
      --cbar-ref-palette-neutral-variant50: #79747eff;
      /* Neutral Variant 60 */
      --cbar-ref-palette-neutral-variant60: #938f99ff;
      /* Neutral Variant 70 */
      --cbar-ref-palette-neutral-variant70: #aea9b4ff;
      /* Neutral Variant 80 */
      --cbar-ref-palette-neutral-variant80: #cac4d0ff;
      /* Neutral Variant 90 */
      --cbar-ref-palette-neutral-variant90: #e7e0ecff;
      /* Neutral Variant 95 */
      --cbar-ref-palette-neutral-variant95: #f5eefaff;
      /* Neutral Variant 99 */
      --cbar-ref-palette-neutral-variant99: #fffbfeff;
      /* Neutral Variant 100 */
      --cbar-ref-palette-neutral-variant100: #ffffffff;
      /* Neutral 0 */
      --cbar-ref-palette-neutral0: #000000ff;
      /* Neutral 10 */
      --cbar-ref-palette-neutral10: #1c1b1fff;
      /* Neutral 20 */
      --cbar-ref-palette-neutral20: #313033ff;
      /* Neutral 30 */
      --cbar-ref-palette-neutral30: #484649ff;
      /* Neutral 40 */
      --cbar-ref-palette-neutral40: #605d62ff;
      /* Neutral 50 */
      --cbar-ref-palette-neutral50: #787579ff;
      /* Neutral 60 */
      --cbar-ref-palette-neutral60: #939094ff;
      /* Neutral 70 */
      --cbar-ref-palette-neutral70: #aeaaaeff;
      /* Neutral 80 */
      --cbar-ref-palette-neutral80: #c9c5caff;
      /* Neutral 90 */
      --cbar-ref-palette-neutral90: #e6e1e5ff;
      /* Neutral 95 */
      --cbar-ref-palette-neutral95: #f4eff4ff;
      /* Neutral 99 */
      --cbar-ref-palette-neutral99: #fffbfeff;
      /* Neutral 100 */
      --cbar-ref-palette-neutral100: #ffffffff;
      /* Black */
      --cbar-ref-palette-black: #000000ff;
      /* White */
      --cbar-ref-palette-white: #ffffffff;
      
      /* SHAPE.CSS TOKENS */
      /* Fully rounded */
      --cbar-sys-shape-corner-full-family: 3px;
      /* Extra large top rounding */
      --cbar-sys-shape-corner-extra-large-top-family: 1px;
      --cbar-sys-shape-corner-extra-large-top-default-size: 0px;
      --cbar-sys-shape-corner-extra-large-top-top-left: 28px;
      --cbar-sys-shape-corner-extra-large-top-top-right-unit: 1px;
      --cbar-sys-shape-corner-extra-large-top-top-right: 28px;
      /* Extra large rounding */
      --cbar-sys-shape-corner-extra-large-family: 1px;
      --cbar-sys-shape-corner-extra-large-default-size-unit: 1px;
      --cbar-sys-shape-corner-extra-large-default-size: 28px;
      /* Large top rounding */
      --cbar-sys-shape-corner-large-top-family: 1px;
      --cbar-sys-shape-corner-large-top-default-size-unit: 1px;
      --cbar-sys-shape-corner-large-top-default-size: 0px;
      --cbar-sys-shape-corner-large-top-top-left-unit: 1px;
      --cbar-sys-shape-corner-large-top-top-left: 16px;
      --cbar-sys-shape-corner-large-top-top-right-unit: 1px;
      --cbar-sys-shape-corner-large-top-top-right: 16px;
      /* Large end rounding */
      --cbar-sys-shape-corner-large-end-family: 1px;
      --cbar-sys-shape-corner-large-end-default-size-unit: 1px;
      --cbar-sys-shape-corner-large-end-default-size: 0px;
      --cbar-sys-shape-corner-large-end-top-right-unit: 1px;
      --cbar-sys-shape-corner-large-end-top-right: 16px;
      --cbar-sys-shape-corner-large-end-bottom-right-unit: 1px;
      --cbar-sys-shape-corner-large-end-bottom-right: 16px;
      /* Large rounding */
      --cbar-sys-shape-corner-large-family: 1px;
      --cbar-sys-shape-corner-large-default-size-unit: 1px;
      --cbar-sys-shape-corner-large-default-size: 16px;
      /* Medium rounding */
      --cbar-sys-shape-corner-medium-family: 1px;
      --cbar-sys-shape-corner-medium-default-size-unit: 1px;
      --cbar-sys-shape-corner-medium-default-size: 12px;
      /* Small rounding */
      --cbar-sys-shape-corner-small-family: 1px;
      --cbar-sys-shape-corner-small-default-size-unit: 1px;
      --cbar-sys-shape-corner-small-default-size: 8px;
      /* Extra small top rounding */
      --cbar-sys-shape-corner-extra-small-top-family: 1px;
      --cbar-sys-shape-corner-extra-small-top-default-size-unit: 1px;
      --cbar-sys-shape-corner-extra-small-top-default-size: 0px;
      --cbar-sys-shape-corner-extra-small-top-top-left-unit: 1px;
      --cbar-sys-shape-corner-extra-small-top-top-left: 4px;
      --cbar-sys-shape-corner-extra-small-top-top-right-unit: 1px;
      --cbar-sys-shape-corner-extra-small-top-top-right: 4px;
      /* Extra small rounding */
      --cbar-sys-shape-corner-extra-small-family: 1px;
      --cbar-sys-shape-corner-extra-small-default-size-unit: 1px;
      --cbar-sys-shape-corner-extra-small-default-size: 4px;
      /* No rounding */
      --cbar-sys-shape-corner-none-family: 1px;
      --cbar-sys-shape-corner-none-default-size-unit: 1px;
      --cbar-sys-shape-corner-none-default-size: 0px;
    
      --cbar-sys-shape-small: var(--cbar-sys-shape-corner-small-default-size);
      --cbar-sys-shape-medium: var(--cbar-sys-shape-corner-medium-default-size);
      --cbar-sys-shape-large: var(--cbar-sys-shape-corner-large-default-size);

      /* STATE.CSS TOKENS */
      /* Dragged state layer opacity */
      --cbar-sys-state-dragged-state-layer-opacity: 0.1599999964237213;
      /* Pressed state layer opacity */
      --cbar-sys-state-pressed-state-layer-opacity: 0.11999999731779099;
      /* Focus state layer opacity */
      --cbar-sys-state-focus-state-layer-opacity: 0.11999999731779099;
      /* Hover state layer opacity */
      --cbar-sys-state-hover-state-layer-opacity: 0.07999999821186066;

      /* TYPOGRAPHY.CSS TOKENS */
      /* Label Small */
      --cbar-sys-typescale-label-small-text-transform: unset;
      --cbar-sys-typescale-label-small-axis-value: unset;
      --cbar-sys-typescale-label-small-font-style: unset;
      --cbar-sys-typescale-label-small-text-decoration: unset;
      /* Label Small line height */
      --cbar-sys-typescale-label-small-line-height-value: 16px;
      --cbar-sys-typescale-label-small-line-height-unit: 2px;
      --cbar-sys-typescale-label-small-line-height: 16px;
      /* Label Small font tracking */
      --cbar-sys-typescale-label-small-tracking-value: 0.5px;
      --cbar-sys-typescale-label-small-tracking-unit: 2px;
      --cbar-sys-typescale-label-small-tracking: 0.5px;
      /* Label Small font size */
      --cbar-sys-typescale-label-small-size-value: 11px;
      --cbar-sys-typescale-label-small-size-unit: 2px;
      --cbar-sys-typescale-label-small-size: 11px;
      /* Label Small font weight */
      --cbar-sys-typescale-label-small-weight: var(--cbar-ref-typeface-weight-medium);
      /* Label Small font name */
      --cbar-sys-typescale-label-small-font: var(--cbar-ref-typeface-plain);
      /* Label Medium */
      --cbar-sys-typescale-label-medium-axis-value: unset;
      --cbar-sys-typescale-label-medium-font-style: unset;
      --cbar-sys-typescale-label-medium-text-decoration: unset;
      /* Label Medium text transform */
      --cbar-sys-typescale-label-medium-text-transform: 1;
      /* Label Medium line height */
      --cbar-sys-typescale-label-medium-line-height-value: 16px;
      --cbar-sys-typescale-label-medium-line-height-unit: 2px;
      --cbar-sys-typescale-label-medium-line-height: 16px;
      /* Label Medium font tracking */
      --cbar-sys-typescale-label-medium-tracking-value: 0.5px;
      --cbar-sys-typescale-label-medium-tracking-unit: 2px;
      --cbar-sys-typescale-label-medium-tracking: 0.5px;
      /* Label Medium font size */
      --cbar-sys-typescale-label-medium-size-value: 12px;
      --cbar-sys-typescale-label-medium-size-unit: 2px;
      --cbar-sys-typescale-label-medium-size: 12px;
      /* Label Medium font weight */
      --cbar-sys-typescale-label-medium-weight: var(--cbar-ref-typeface-weight-medium);
      /* Label Medium font name */
      --cbar-sys-typescale-label-medium-font: var(--cbar-ref-typeface-plain);
      /* Label Large */
      --cbar-sys-typescale-label-large-text-transform: unset;
      --cbar-sys-typescale-label-large-axis-value: unset;
      --cbar-sys-typescale-label-large-font-style: unset;
      --cbar-sys-typescale-label-large-text-decoration: unset;
      /* Label Large line height */
      --cbar-sys-typescale-label-large-line-height-value: 20px;
      --cbar-sys-typescale-label-large-line-height-unit: 2px;
      --cbar-sys-typescale-label-large-line-height: 20px;
      /* Label Large font tracking */
      --cbar-sys-typescale-label-large-tracking-value: 0.10000000149011612px;
      --cbar-sys-typescale-label-large-tracking-unit: 2px;
      --cbar-sys-typescale-label-large-tracking: 0.10000000149011612px;
      /* Label Large font size */
      --cbar-sys-typescale-label-large-size-value: 14px;
      --cbar-sys-typescale-label-large-size-unit: 2px;
      --cbar-sys-typescale-label-large-size: 14px;
      /* Label Large font weight */
      --cbar-sys-typescale-label-large-weight: var(--cbar-ref-typeface-weight-medium);
      /* Label Large font name */
      --cbar-sys-typescale-label-large-font: var(--cbar-ref-typeface-plain);
      /* Body Small */
      --cbar-sys-typescale-body-small-text-transform: unset;
      --cbar-sys-typescale-body-small-axis-value: unset;
      --cbar-sys-typescale-body-small-font-style: unset;
      --cbar-sys-typescale-body-small-text-decoration: unset;
      /* Body Small line height */
      --cbar-sys-typescale-body-small-line-height-value: 16px;
      --cbar-sys-typescale-body-small-line-height-unit: 2px;
      --cbar-sys-typescale-body-small-line-height: 16px;
      /* Body Small font tracking */
      --cbar-sys-typescale-body-small-tracking-value: 0.4000000059604645px;
      --cbar-sys-typescale-body-small-tracking-unit: 2px;
      --cbar-sys-typescale-body-small-tracking: 0.4000000059604645px;
      /* Body Small font size */
      --cbar-sys-typescale-body-small-size-value: 12px;
      --cbar-sys-typescale-body-small-size-unit: 2px;
      --cbar-sys-typescale-body-small-size: 12px;
      /* Body Small font weight */
      --cbar-sys-typescale-body-small-weight: var(--cbar-ref-typeface-weight-regular);
      /* Body Small font name */
      --cbar-sys-typescale-body-small-font: var(--cbar-ref-typeface-plain);
      /* Body Medium */
      --cbar-sys-typescale-body-medium-text-transform: unset;
      --cbar-sys-typescale-body-medium-axis-value: unset;
      --cbar-sys-typescale-body-medium-font-style: unset;
      --cbar-sys-typescale-body-medium-text-decoration: unset;
      /* Body Medium line height */
      --cbar-sys-typescale-body-medium-line-height-value: 20px;
      --cbar-sys-typescale-body-medium-line-height-unit: 2px;
      --cbar-sys-typescale-body-medium-line-height: 20px;
      /* Body Medium font tracking */
      --cbar-sys-typescale-body-medium-tracking-value: 0.25px;
      --cbar-sys-typescale-body-medium-tracking-unit: 2px;
      --cbar-sys-typescale-body-medium-tracking: 0.25px;
      /* Body Medium font size */
      --cbar-sys-typescale-body-medium-size-value: 14px;
      --cbar-sys-typescale-body-medium-size-unit: 2px;
      --cbar-sys-typescale-body-medium-size: 14px;
      /* Body Medium font weight */
      --cbar-sys-typescale-body-medium-weight: var(--cbar-ref-typeface-weight-regular);
      /* Body Medium font name */
      --cbar-sys-typescale-body-medium-font: var(--cbar-ref-typeface-plain);
      /* Body Large */
      --cbar-sys-typescale-body-large-text-transform: unset;
      --cbar-sys-typescale-body-large-axis-value: unset;
      --cbar-sys-typescale-body-large-font-style: unset;
      --cbar-sys-typescale-body-large-text-decoration: unset;
      /* Body Large line height */
      --cbar-sys-typescale-body-large-line-height-value: 24px;
      --cbar-sys-typescale-body-large-line-height-unit: 2px;
      --cbar-sys-typescale-body-large-line-height: 24px;
      /* Body Large font tracking */
      --cbar-sys-typescale-body-large-tracking-value: 0.5px;
      --cbar-sys-typescale-body-large-tracking-unit: 2px;
      --cbar-sys-typescale-body-large-tracking: 0.5px;
      /* Body Large font size */
      --cbar-sys-typescale-body-large-size-value: 16px;
      --cbar-sys-typescale-body-large-size-unit: 2px;
      --cbar-sys-typescale-body-large-size: 16px;
      /* Body Large font weight */
      --cbar-sys-typescale-body-large-weight: var(--cbar-ref-typeface-weight-regular);
      /* Body Large font name */
      --cbar-sys-typescale-body-large-font: var(--cbar-ref-typeface-plain);
      /* Title Small */
      --cbar-sys-typescale-title-small-text-transform: unset;
      --cbar-sys-typescale-title-small-axis-value: unset;
      --cbar-sys-typescale-title-small-font-style: unset;
      --cbar-sys-typescale-title-small-text-decoration: unset;
      /* Title Small line height */
      --cbar-sys-typescale-title-small-line-height-value: 20px;
      --cbar-sys-typescale-title-small-line-height-unit: 2px;
      --cbar-sys-typescale-title-small-line-height: 20px;
      /* Title Small font tracking */
      --cbar-sys-typescale-title-small-tracking-value: 0.10000000149011612px;
      --cbar-sys-typescale-title-small-tracking-unit: 2px;
      --cbar-sys-typescale-title-small-tracking: 0.10000000149011612px;
      /* Title Small font size */
      --cbar-sys-typescale-title-small-size-value: 14px;
      --cbar-sys-typescale-title-small-size-unit: 2px;
      --cbar-sys-typescale-title-small-size: 14px;
      /* Title Small font weight */
      --cbar-sys-typescale-title-small-weight: var(--cbar-ref-typeface-weight-medium);
      /* Title Small font name */
      --cbar-sys-typescale-title-small-font: var(--cbar-ref-typeface-plain);
      /* Title Medium */
      --cbar-sys-typescale-title-medium-text-transform: unset;
      --cbar-sys-typescale-title-medium-axis-value: unset;
      --cbar-sys-typescale-title-medium-font-style: unset;
      --cbar-sys-typescale-title-medium-text-decoration: unset;
      /* Title Medium line height */
      --cbar-sys-typescale-title-medium-line-height-value: 24px;
      --cbar-sys-typescale-title-medium-line-height-unit: 2px;
      --cbar-sys-typescale-title-medium-line-height: 24px;
      /* Title Medium font tracking */
      --cbar-sys-typescale-title-medium-tracking-value: 0.15000000596046448px;
      --cbar-sys-typescale-title-medium-tracking-unit: 2px;
      --cbar-sys-typescale-title-medium-tracking: 0.15000000596046448px;
      /* Title Medium font size */
      --cbar-sys-typescale-title-medium-size-value: 16px;
      --cbar-sys-typescale-title-medium-size-unit: 2px;
      --cbar-sys-typescale-title-medium-size: 16px;
      /* Title Medium font weight */
      --cbar-sys-typescale-title-medium-weight: var(--cbar-ref-typeface-weight-medium);
      /* Title Medium font name */
      --cbar-sys-typescale-title-medium-font: var(--cbar-ref-typeface-plain);
      /* Title Large */
      --cbar-sys-typescale-title-large-text-transform: unset;
      --cbar-sys-typescale-title-large-axis-value: unset;
      --cbar-sys-typescale-title-large-font-style: unset;
      --cbar-sys-typescale-title-large-text-decoration: unset;
      /* Title Large line height */
      --cbar-sys-typescale-title-large-line-height-value: 28px;
      --cbar-sys-typescale-title-large-line-height-unit: 2px;
      --cbar-sys-typescale-title-large-line-height: 28px;
      /* Title Large font tracking */
      --cbar-sys-typescale-title-large-tracking-value: 0px;
      --cbar-sys-typescale-title-large-tracking-unit: 2px;
      --cbar-sys-typescale-title-large-tracking: 0px;
      /* Title Large font size */
      --cbar-sys-typescale-title-large-size-value: 22px;
      --cbar-sys-typescale-title-large-size-unit: 2px;
      --cbar-sys-typescale-title-large-size: 22px;
      /* Title Large font weight */
      --cbar-sys-typescale-title-large-weight: var(--cbar-ref-typeface-weight-regular);
      /* Title Large font name */
      --cbar-sys-typescale-title-large-font: var(--cbar-ref-typeface-brand);
      /* Headline Small */
      --cbar-sys-typescale-headline-small-text-transform: unset;
      --cbar-sys-typescale-headline-small-axis-value: unset;
      --cbar-sys-typescale-headline-small-font-style: unset;
      --cbar-sys-typescale-headline-small-text-decoration: unset;
      /* Headline Small line height */
      --cbar-sys-typescale-headline-small-line-height-value: 32px;
      --cbar-sys-typescale-headline-small-line-height-unit: 2px;
      --cbar-sys-typescale-headline-small-line-height: 32px;
      /* Headline Small font tracking */
      --cbar-sys-typescale-headline-small-tracking-value: 0px;
      --cbar-sys-typescale-headline-small-tracking-unit: 2px;
      --cbar-sys-typescale-headline-small-tracking: 0px;
      /* Headline Small font size */
      --cbar-sys-typescale-headline-small-size-value: 24px;
      --cbar-sys-typescale-headline-small-size-unit: 2px;
      --cbar-sys-typescale-headline-small-size: 24px;
      /* Headline Small font weight */
      --cbar-sys-typescale-headline-small-weight: var(
        --cbar-ref-typeface-weight-regular
      );
      /* Headline Small font name */
      --cbar-sys-typescale-headline-small-font: var(--cbar-ref-typeface-brand);
      /* Headline Medium */
      --cbar-sys-typescale-headline-medium-text-transform: unset;
      --cbar-sys-typescale-headline-medium-axis-value: unset;
      --cbar-sys-typescale-headline-medium-font-style: unset;
      --cbar-sys-typescale-headline-medium-text-decoration: unset;
      /* Headline Medium line height */
      --cbar-sys-typescale-headline-medium-line-height-value: 36px;
      --cbar-sys-typescale-headline-medium-line-height-unit: 2px;
      --cbar-sys-typescale-headline-medium-line-height: 36px;
      /* Headline Medium font tracking */
      --cbar-sys-typescale-headline-medium-tracking-value: 0px;
      --cbar-sys-typescale-headline-medium-tracking-unit: 2px;
      --cbar-sys-typescale-headline-medium-tracking: 0px;
      /* Headline Medium font size */
      --cbar-sys-typescale-headline-medium-size-value: 28px;
      --cbar-sys-typescale-headline-medium-size-unit: 2px;
      --cbar-sys-typescale-headline-medium-size: 28px;
      /* Headline Medium font weight */
      --cbar-sys-typescale-headline-medium-weight: var(
        --cbar-ref-typeface-weight-regular
      );
      /* Headline Medium font name */
      --cbar-sys-typescale-headline-medium-font: var(--cbar-ref-typeface-brand);
      /* Headline Large */
      --cbar-sys-typescale-headline-large-text-transform: unset;
      --cbar-sys-typescale-headline-large-axis-value: unset;
      --cbar-sys-typescale-headline-large-font-style: unset;
      --cbar-sys-typescale-headline-large-text-decoration: unset;
      /* Headline Large line height */
      --cbar-sys-typescale-headline-large-line-height-value: 40px;
      --cbar-sys-typescale-headline-large-line-height-unit: 2px;
      --cbar-sys-typescale-headline-large-line-height: 40px;
      /* Headline Large font tracking */
      --cbar-sys-typescale-headline-large-tracking-value: 0px;
      --cbar-sys-typescale-headline-large-tracking-unit: 2px;
      --cbar-sys-typescale-headline-large-tracking: 0px;
      /* Headline Large font size */
      --cbar-sys-typescale-headline-large-size-value: 32px;
      --cbar-sys-typescale-headline-large-size-unit: 2px;
      --cbar-sys-typescale-headline-large-size: 32px;
      /* Headline Large font name */
      --cbar-sys-typescale-headline-large-font: var(--cbar-ref-typeface-brand);
      /* Headline Large font weight */
      --cbar-sys-typescale-headline-large-weight: var(
        --cbar-ref-typeface-weight-regular
      );
      /* Display Small */
      --cbar-sys-typescale-display-small-text-transform: unset;
      --cbar-sys-typescale-display-small-axis-value: unset;
      --cbar-sys-typescale-display-small-font-style: unset;
      --cbar-sys-typescale-display-small-text-decoration: unset;
      /* Display Small line height */
      --cbar-sys-typescale-display-small-line-height-value: 44px;
      --cbar-sys-typescale-display-small-line-height-unit: 2px;
      --cbar-sys-typescale-display-small-line-height: 44px;
      /* Display Small font tracking */
      --cbar-sys-typescale-display-small-tracking-value: 0px;
      --cbar-sys-typescale-display-small-tracking-unit: 2px;
      --cbar-sys-typescale-display-small-tracking: 0px;
      /* Display Small font size */
      --cbar-sys-typescale-display-small-size-value: 36px;
      --cbar-sys-typescale-display-small-size-unit: 2px;
      --cbar-sys-typescale-display-small-size: 36px;
      /* Display Small font weight */
      --cbar-sys-typescale-display-small-weight: var(
        --cbar-ref-typeface-weight-regular
      );
      /* Display Small font name */
      --cbar-sys-typescale-display-small-font: var(--cbar-ref-typeface-brand);
      /* Display Medium */
      --cbar-sys-typescale-display-medium-text-transform: unset;
      --cbar-sys-typescale-display-medium-axis-value: unset;
      --cbar-sys-typescale-display-medium-font-style: unset;
      --cbar-sys-typescale-display-medium-text-decoration: unset;
      /* Display Medium line height */
      --cbar-sys-typescale-display-medium-line-height-value: 52px;
      --cbar-sys-typescale-display-medium-line-height-unit: 2px;
      --cbar-sys-typescale-display-medium-line-height: 52px;
      /* Display Medium font tracking */
      --cbar-sys-typescale-display-medium-tracking-value: 0px;
      --cbar-sys-typescale-display-medium-tracking-unit: 2px;
      --cbar-sys-typescale-display-medium-tracking: 0px;
      /* Display Medium font size */
      --cbar-sys-typescale-display-medium-size-value: 45px;
      --cbar-sys-typescale-display-medium-size-unit: 2px;
      --cbar-sys-typescale-display-medium-size: 45px;
      /* Display Medium font weight */
      --cbar-sys-typescale-display-medium-weight: var(
        --cbar-ref-typeface-weight-regular
      );
      /* Display Medium font name */
      --cbar-sys-typescale-display-medium-font: var(--cbar-ref-typeface-brand);
      /* Display Large */
      --cbar-sys-typescale-display-large-text-transform: unset;
      --cbar-sys-typescale-display-large-axis-value: unset;
      --cbar-sys-typescale-display-large-font-style: unset;
      --cbar-sys-typescale-display-large-text-decoration: unset;
      /* Display Large line height */
      --cbar-sys-typescale-display-large-line-height-value: 64px;
      --cbar-sys-typescale-display-large-line-height-unit: 2px;
      --cbar-sys-typescale-display-large-line-height: 64px;
      /* Display Large font tracking */
      --cbar-sys-typescale-display-large-tracking-value: -0.25px;
      --cbar-sys-typescale-display-large-tracking-unit: 2px;
      --cbar-sys-typescale-display-large-tracking: -0.25px;
      /* Display Large font size */
      --cbar-sys-typescale-display-large-size-value: 57px;
      --cbar-sys-typescale-display-large-size-unit: 2px;
      --cbar-sys-typescale-display-large-size: 57px;
      /* Display Large font weight */
      --cbar-sys-typescale-display-large-weight: var(
        --cbar-ref-typeface-weight-regular
      );
      /* Display Large font name */
      --cbar-sys-typescale-display-large-font: var(--cbar-ref-typeface-brand);
      /* Plain typeface */
      --cbar-ref-typeface-plain: Roboto;
      /* Brand typeface */
      --cbar-ref-typeface-brand: Roboto;
      /* Bold weight */
      --cbar-ref-typeface-weight-bold: 700;
      /* Medium weight */
      --cbar-ref-typeface-weight-medium: 500;
      /* Regular weight */
      --cbar-ref-typeface-weight-regular: 400;
    }
    
    @media (prefers-color-scheme: light) {
        :host{
          /* LIGHT.CSS THEME TOKENS */
          color-scheme: light;
          /* Surface tint */
          --cbar-sys-color-surface-tint: var(--cbar-sys-color-primary);
          /* Surface tint color */
          --cbar-sys-color-surface-tint-color: var(--cbar-sys-color-primary);
          /* On error container */
          --cbar-sys-color-on-error-container: var(--cbar-ref-palette-error10);
          /* On error */
          --cbar-sys-color-on-error: var(--cbar-ref-palette-error100);
          /* Error container */
          --cbar-sys-color-error-container: var(--cbar-ref-palette-error90);
          /* On tertiary container */
          --cbar-sys-color-on-tertiary-container: var(--cbar-ref-palette-tertiary10);
          /* On tertiary */
          --cbar-sys-color-on-tertiary: var(--cbar-ref-palette-tertiary100);
          /* Tertiary container */
          --cbar-sys-color-tertiary-container: var(--cbar-ref-palette-tertiary90);
          /* Tertiary */
          --cbar-sys-color-tertiary: var(--cbar-ref-palette-tertiary40);
          /* Shadow */
          --cbar-sys-color-shadow: var(--cbar-ref-palette-neutral0);
          /* Error */
          --cbar-sys-color-error: var(--cbar-ref-palette-error40);
          /* Outline */
          --cbar-sys-color-outline: var(--cbar-ref-palette-neutral-variant50);
          /* On background */
          --cbar-sys-color-on-background: var(--cbar-ref-palette-neutral10);
          /* Background */
          --cbar-sys-color-background: var(--cbar-ref-palette-neutral99);
          /* Inverse on surface */
          --cbar-sys-color-inverse-on-surface: var(--cbar-ref-palette-neutral95);
          /* Inverse surface */
          --cbar-sys-color-inverse-surface: var(--cbar-ref-palette-neutral20);
          /* On surface variant */
          --cbar-sys-color-on-surface-variant: var(--cbar-ref-palette-neutral-variant30);
          /* On surface */
          --cbar-sys-color-on-surface: var(--cbar-ref-palette-neutral10);
          /* Surface Variant */
          --cbar-sys-color-surface-variant: var(--cbar-ref-palette-neutral-variant90);
          /* Surface */
          --cbar-sys-color-surface: var(--cbar-ref-palette-neutral99);
          /* On secondary container */
          --cbar-sys-color-on-secondary-container: var(--cbar-ref-palette-secondary10);
          /* On secondary */
          --cbar-sys-color-on-secondary: var(--cbar-ref-palette-secondary100);
          /* Secondary container */
          --cbar-sys-color-secondary-container: var(--cbar-ref-palette-secondary90);
          /* Secondary */
          --cbar-sys-color-secondary: var(--cbar-ref-palette-secondary40);
          /* Inverse primary */
          --cbar-sys-color-inverse-primary: var(--cbar-ref-palette-primary80);
          /* On primary container */
          --cbar-sys-color-on-primary-container: var(--cbar-ref-palette-primary10);
          /* On primary */
          --cbar-sys-color-on-primary: var(--cbar-ref-palette-primary100);
          /* Primary container */
          --cbar-sys-color-primary-container: var(--cbar-ref-palette-primary90);
          /* Primary */
          --cbar-sys-color-primary: var(--cbar-ref-palette-primary40);
        }
    }
    
    @media(prefers-color-scheme: dark){
        :host{
            color-scheme: dark;
            /* Surface tint */
            --cbar-sys-color-surface-tint: var(--cbar-sys-color-primary);
            /* Surface tint color */
            --cbar-sys-color-surface-tint-color: var(--cbar-sys-color-primary);
            /* On error container */
            --cbar-sys-color-on-error-container: var(--cbar-ref-palette-error80);
            /* On error */
            --cbar-sys-color-on-error: var(--cbar-ref-palette-error20);
            /* Error container */
            --cbar-sys-color-error-container: var(--cbar-ref-palette-error30);
            /* On tertiary container */
            --cbar-sys-color-on-tertiary-container: var(--cbar-ref-palette-tertiary90);
            /* On tertiary */
            --cbar-sys-color-on-tertiary: var(--cbar-ref-palette-tertiary20);
            /* Tertiary container */
            --cbar-sys-color-tertiary-container: var(--cbar-ref-palette-tertiary30);
            /* Tertiary */
            --cbar-sys-color-tertiary: var(--cbar-ref-palette-tertiary80);
            /* Shadow */
            --cbar-sys-color-shadow: var(--cbar-ref-palette-neutral0);
            /* Error */
            --cbar-sys-color-error: var(--cbar-ref-palette-error80);
            /* Outline */
            --cbar-sys-color-outline: var(--cbar-ref-palette-neutral-variant60);
            /* On background */
            --cbar-sys-color-on-background: var(--cbar-ref-palette-neutral90);
            /* Background */
            --cbar-sys-color-background: var(--cbar-ref-palette-neutral10);
            /* Inverse on surface */
            --cbar-sys-color-inverse-on-surface: var(--cbar-ref-palette-neutral20);
            /* Inverse surface */
            --cbar-sys-color-inverse-surface: var(--cbar-ref-palette-neutral90);
            /* On surface variant */
            --cbar-sys-color-on-surface-variant: var(--cbar-ref-palette-neutral-variant80);
            /* On surface */
            --cbar-sys-color-on-surface: var(--cbar-ref-palette-neutral90);
            /* Surface Variant */
            --cbar-sys-color-surface-variant: var(--cbar-ref-palette-neutral-variant30);
            /* Surface */
            --cbar-sys-color-surface: var(--cbar-ref-palette-neutral10);
            /* On secondary container */
            --cbar-sys-color-on-secondary-container: var(--cbar-ref-palette-secondary90);
            /* On secondary */
            --cbar-sys-color-on-secondary: var(--cbar-ref-palette-secondary20);
            /* Secondary container */
            --cbar-sys-color-secondary-container: var(--cbar-ref-palette-secondary30);
            /* Secondary */
            --cbar-sys-color-secondary: var(--cbar-ref-palette-secondary80);
            /* Inverse primary */
            --cbar-sys-color-inverse-primary: var(--cbar-ref-palette-primary40);
            /* On primary container */
            --cbar-sys-color-on-primary-container: var(--cbar-ref-palette-primary90);
            /* On primary */
            --cbar-sys-color-on-primary: var(--cbar-ref-palette-primary20);
            /* Primary container */
            --cbar-sys-color-primary-container: var(--cbar-ref-palette-primary30);
            /* Primary */
            --cbar-sys-color-primary: var(--cbar-ref-palette-primary80);
        }
    }
    
    /* STYLES BELOW HERE ARE FROM CBAR TOKENS GENERATED IN GITLAB, COLORS.CSS */
    .primary {
      color: var(--cbar-sys-color-on-primary);
      background-color: var(--cbar-sys-color-primary);
    }
    .on-primary {
      color: var(--cbar-sys-color-primary);
      background-color: var(--cbar-sys-color-on-primary);
    }
    .primary-container {
      color: var(--cbar-sys-color-on-primary-container);
      background-color: var(--cbar-sys-color-primary-container);
    }
    .on-primary-container {
      color: var(--cbar-sys-color-primary-container);
      background-color: var(--cbar-sys-color-on-primary-container);
    }
    .secondary {
      color: var(--cbar-sys-color-on-secondary);
      background-color: var(--cbar-sys-color-secondary);
    }
    .on-secondary {
      color: var(--cbar-sys-color-secondary);
      background-color: var(--cbar-sys-color-on-secondary);
    }
    .secondary-container {
      color: var(--cbar-sys-color-on-secondary-container);
      background-color: var(--cbar-sys-color-secondary-container);
    }
    .on-secondary-container {
      color: var(--cbar-sys-color-secondary-container);
      background-color: var(--cbar-sys-color-on-secondary-container);
    }
    .tertiary {
      color: var(--cbar-sys-color-on-tertiary);
      background-color: var(--cbar-sys-color-tertiary);
    }
    .on-tertiary {
      color: var(--cbar-sys-color-tertiary);
      background-color: var(--cbar-sys-color-on-tertiary);
    }
    .tertiary-container {
      color: var(--cbar-sys-color-on-tertiary-container);
      background-color: var(--cbar-sys-color-tertiary-container);
    }
    .on-tertiary-container {
      color: var(--cbar-sys-color-tertiary-container);
      background-color: var(--cbar-sys-color-on-tertiary-container);
    }
    .background {
      color: var(--cbar-sys-color-on-background);
      background-color: var(--cbar-sys-color-background);
    }
    .surface {
      color: var(--cbar-sys-color-on-surface);
      background-color: var(--cbar-sys-color-surface);
    }
    .surface-variant {
      color: var(--cbar-sys-color-on-surface-variant);
      background-color: var(--cbar-sys-color-surface-variant);
    }
    .on-surface-variant {
      color: var(--cbar-sys-color-surface-variant);
      background-color: var(--cbar-sys-color-on-surface-variant);
    }
    .outline {
      border: 1px solid var(--cbar-sys-color-outline);
    }
    .inverse-surface {
      color: var(--cbar-sys-color-on-inverse-surface);
      background-color: var(--cbar-sys-color-inverse-surface);
    }
    .on-inverse-surface {
      color: var(--cbar-sys-color-inverse-surface);
      background-color: var(--cbar-sys-color-on-inverse-surface);
    }
    .inverse-primary {
      color: var(--cbar-sys-color-on-inverse-primary);
      background-color: var(--cbar-sys-color-inverse-primary);
    }
    .on-inverse-primary {
      color: var(--cbar-sys-color-inverse-primary);
      background-color: var(--cbar-sys-color-on-inverse-primary);
    }
    .surface-tint {
      background-color: var(--cbar-sys-color-on-surface-tint);
    }
    .error {
      color: var(--cbar-sys-color-on-error);
      background-color: var(--cbar-sys-color-error);
    }
    .on-error {
      color: var(--cbar-sys-color-error);
      background-color: var(--cbar-sys-color-on-error);
    }
    .error-container {
      color: var(--cbar-sys-color-on-error-container);
      background-color: var(--cbar-sys-color-error-container);
    }
    .on-error-container {
      color: var(--cbar-sys-color-error-container);
      background-color: var(--cbar-sys-color-on-error-container);
    }
    .black {
      background-color: var(--cbar-ref-palette-black);
    }
    .black-text {
      color: var(--cbar-ref-palette-black);
    }
    .white {
      background-color: var(--cbar-ref-palette-white);
    }
    .white-text {
      color: var(--cbar-ref-palette-white);
    }
    
    /* ELEVATION.CSS STYLES HERE FROM TOKEN GEN */
    .elevation-0 {
      box-shadow: var(--cbar-sys-elevation-level0);
    }
    .elevation-1 {
      box-shadow: var(--cbar-sys-elevation-level1);
    }
    .elevation-2 {
      box-shadow: var(--cbar-sys-elevation-level2);
    }
    .elevation-3 {
      box-shadow: var(--cbar-sys-elevation-level3);
    }
    .elevation-4 {
      box-shadow: var(--cbar-sys-elevation-level4);
    }
    .elevation-5 {
      box-shadow: var(--cbar-sys-elevation-level5);
    }
    
    /* MOTION.CSS HERE FROM GENERATED TOKENS */
    .duration-50 {
      transition-duration: var(--cbar-sys-motion-duration-50);
    }
    .duration-100 {
      transition-duration: var(--cbar-sys-motion-duration-100);
    }
    .duration-150 {
      transition-duration: var(--cbar-sys-motion-duration-150);
    }
    .duration-200 {
      transition-duration: var(--cbar-sys-motion-duration-200);
    }
    .duration-250 {
      transition-duration: var(--cbar-sys-motion-duration-250);
    }
    .duration-300 {
      transition-duration: var(--cbar-sys-motion-duration-300);
    }
    .duration-350 {
      transition-duration: var(--cbar-sys-motion-duration-350);
    }
    .duration-400 {
      transition-duration: var(--cbar-sys-motion-duration-400);
    }
    .duration-450 {
      transition-duration: var(--cbar-sys-motion-duration-450);
    }
    .duration-500 {
      transition-duration: var(--cbar-sys-motion-duration-500);
    }
    .duration-550 {
      transition-duration: var(--cbar-sys-motion-duration-550);
    }
    .duration-600 {
      transition-duration: var(--cbar-sys-motion-duration-600);
    }
    .duration-700 {
      transition-duration: var(--cbar-sys-motion-duration-700);
    }
    .duration-800 {
      transition-duration: var(--cbar-sys-motion-duration-800);
    }
    .duration-900 {
      transition-duration: var(--cbar-sys-motion-duration-900);
    }
    .duration-1000 {
      transition-duration: var(--cbar-sys-motion-duration-1000);
    }
    .easing-standard {
      transition-timing-function: cubic-bezier(
        var(--cbar-sys-motion-easing-standard-x0),
        var(--cbar-sys-motion-easing-standard-y0),
        var(--cbar-sys-motion-easing-standard-x1),
        var(--cbar-sys-motion-easing-standard-y1)
      );
    }
    .easing-linear {
      transition-timing-function: cubic-bezier(
        var(--cbar-sys-motion-easing-linear-x0),
        var(--cbar-sys-motion-easing-linear-y0),
        var(--cbar-sys-motion-easing-linear-x1),
        var(--cbar-sys-motion-easing-linear-y1)
      );
    }
    .easing-standard-accelerate {
      transition-timing-function: cubic-bezier(
        var(--cbar-sys-motion-easing-standard-accelerate-x0),
        var(--cbar-sys-motion-easing-standard-accelerate-y0),
        var(--cbar-sys-motion-easing-standard-accelerate-x1),
        var(--cbar-sys-motion-easing-standard-accelerate-y1)
      );
    }
    .easing-standard-decelerate {
      transition-timing-function: cubic-bezier(
        var(--cbar-sys-motion-easing-standard-decelerate-x0),
        var(--cbar-sys-motion-easing-standard-decelerate-y0),
        var(--cbar-sys-motion-easing-standard-decelerate-x1),
        var(--cbar-sys-motion-easing-standard-decelerate-y1)
      );
    }
    .easing-emphasized {
      transition-timing-function: cubic-bezier(
        var(--cbar-sys-motion-easing-emphasized-x0),
        var(--cbar-sys-motion-easing-emphasized-y0),
        var(--cbar-sys-motion-easing-emphasized-x1),
        var(--cbar-sys-motion-easing-emphasized-y1)
      );
    }

    /* SHAPE.CSS HERE FROM GENERATED TOKENS */
    shape-none {
      border-radius: var(--cbar-sys-shape-corner-none-default-size);
    }
    .shape-extra-small {
      border-radius: var(--cbar-sys-shape-corner-extra-small-default-size);
    }
    .shape-small {
      border-radius: var(--cbar-sys-shape-corner-small-default-size);
    }
    .shape-medium {
      border-radius: var(--cbar-sys-shape-corner-medium-default-size);
    }
    .shape-large {
      border-radius: var(--cbar-sys-shape-corner-large-default-size);
    }
    .shape-extra-large {
      border-radius: var(--cbar-sys-shape-corner-extra-large-default-size);
    }
    .extra-small-top {
      border-top-left-radius: var(--cbar-sys-shape-corner-extra-small-top-top-left);
      border-top-right-radius: var(--cbar-sys-shape-corner-extra-small-top-top-right);
    }
    .large-end {
      border-top-right-radius: var(--cbar-sys-shape-corner-large-end-top-right);
      border-bottom-right-radius: var(--cbar-sys-shape-corner-large-end-bottom-right);
    }
    .large-top {
      border-top-left-radius: var(--cbar-sys-shape-corner-large-top-top-left);
      border-top-right-radius: var(--cbar-sys-shape-corner-large-top-top-right);
    }
    .extra-large-top {
      border-top-left-radius: var(--cbar-sys-shape-corner-extra-large-top-top-left);
      border-top-right-radius: var(--cbar-sys-shape-corner-extra-large-top-top-right);
    }

    /* STATE.CSS HERE FROM GENERATED TOKENS */
    .hover-state-layer {
      opacity: var(--cbar-sys-state-hover-state-layer-opacity);
    }
    .pressed-state-layer {
      opacity: var(--cbar-sys-state-pressed-state-layer-opacity);
    }
    .dragged-state-layer {
      opacity: var(--cbar-sys-state-dragged-state-layer-opacity);
    }
    .focus-state-layer {
      opacity: var(--cbar-sys-state-focus-state-layer-opacity);
    }

    /* TYPOGRAPHY.CSS FROM GENERATED TOKENS */
    /* Label Small */
    .label-small {
      font-family: var(--cbar-sys-typescale-label-small-font);
      font-weight: var(--cbar-sys-typescale-label-small-weight);
      font-size: var(--cbar-sys-typescale-label-small-size);
      font-style: var(--cbar-sys-typescale-label-small-font-style);
      letter-spacing: var(--cbar-sys-typescale-label-small-tracking);
      line-height: var(--cbar-sys-typescale-label-small-line-height);
      text-transform: var(--cbar-sys-typescale-label-small-text-transform);
      text-decoration: var(--cbar-sys-typescale-label-small-text-decoration);
    }
    /* Label Medium */
    .label-medium {
      font-family: var(--cbar-sys-typescale-label-medium-font);
      font-weight: var(--cbar-sys-typescale-label-medium-weight);
      font-size: var(--cbar-sys-typescale-label-medium-size);
      font-style: var(--cbar-sys-typescale-label-medium-font-style);
      letter-spacing: var(--cbar-sys-typescale-label-medium-tracking);
      line-height: var(--cbar-sys-typescale-label-medium-line-height);
      text-transform: var(--cbar-sys-typescale-label-medium-text-transform);
      text-decoration: var(--cbar-sys-typescale-label-medium-text-decoration);
    }
    /* Label Large */
    .label-large {
      font-family: var(--cbar-sys-typescale-label-large-font);
      font-weight: var(--cbar-sys-typescale-label-large-weight);
      font-size: var(--cbar-sys-typescale-label-large-size);
      font-style: var(--cbar-sys-typescale-label-large-font-style);
      letter-spacing: var(--cbar-sys-typescale-label-large-tracking);
      line-height: var(--cbar-sys-typescale-label-large-line-height);
      text-transform: var(--cbar-sys-typescale-label-large-text-transform);
      text-decoration: var(--cbar-sys-typescale-label-large-text-decoration);
    }
    /* Body Small */
    .body-small {
      font-family: var(--cbar-sys-typescale-body-small-font);
      font-weight: var(--cbar-sys-typescale-body-small-weight);
      font-size: var(--cbar-sys-typescale-body-small-size);
      font-style: var(--cbar-sys-typescale-body-small-font-style);
      letter-spacing: var(--cbar-sys-typescale-body-small-tracking);
      line-height: var(--cbar-sys-typescale-body-small-line-height);
      text-transform: var(--cbar-sys-typescale-body-small-text-transform);
      text-decoration: var(--cbar-sys-typescale-body-small-text-decoration);
    }
    /* Body Medium */
    .body-medium {
      font-family: var(--cbar-sys-typescale-body-medium-font);
      font-weight: var(--cbar-sys-typescale-body-medium-weight);
      font-size: var(--cbar-sys-typescale-body-medium-size);
      font-style: var(--cbar-sys-typescale-body-medium-font-style);
      letter-spacing: var(--cbar-sys-typescale-body-medium-tracking);
      line-height: var(--cbar-sys-typescale-body-medium-line-height);
      text-transform: var(--cbar-sys-typescale-body-medium-text-transform);
      text-decoration: var(--cbar-sys-typescale-body-medium-text-decoration);
    }
    /* Body Large */
    .body-large {
      font-family: var(--cbar-sys-typescale-body-large-font);
      font-weight: var(--cbar-sys-typescale-body-large-weight);
      font-size: var(--cbar-sys-typescale-body-large-size);
      font-style: var(--cbar-sys-typescale-body-large-font-style);
      letter-spacing: var(--cbar-sys-typescale-body-large-tracking);
      line-height: var(--cbar-sys-typescale-body-large-line-height);
      text-transform: var(--cbar-sys-typescale-body-large-text-transform);
      text-decoration: var(--cbar-sys-typescale-body-large-text-decoration);
    }
    /* Title Small */
    .title-small {
      font-family: var(--cbar-sys-typescale-title-small-font);
      font-weight: var(--cbar-sys-typescale-title-small-weight);
      font-size: var(--cbar-sys-typescale-title-small-size);
      font-style: var(--cbar-sys-typescale-title-small-font-style);
      letter-spacing: var(--cbar-sys-typescale-title-small-tracking);
      line-height: var(--cbar-sys-typescale-title-small-line-height);
      text-transform: var(--cbar-sys-typescale-title-small-text-transform);
      text-decoration: var(--cbar-sys-typescale-title-small-text-decoration);
    }
    /* Title Medium */
    .title-medium {
      font-family: var(--cbar-sys-typescale-title-medium-font);
      font-weight: var(--cbar-sys-typescale-title-medium-weight);
      font-size: var(--cbar-sys-typescale-title-medium-size);
      font-style: var(--cbar-sys-typescale-title-medium-font-style);
      letter-spacing: var(--cbar-sys-typescale-title-medium-tracking);
      line-height: var(--cbar-sys-typescale-title-medium-line-height);
      text-transform: var(--cbar-sys-typescale-title-medium-text-transform);
      text-decoration: var(--cbar-sys-typescale-title-medium-text-decoration);
    }
    /* Title Large */
    .title-large {
      font-family: var(--cbar-sys-typescale-title-large-font);
      font-weight: var(--cbar-sys-typescale-title-large-weight);
      font-size: var(--cbar-sys-typescale-title-large-size);
      font-style: var(--cbar-sys-typescale-title-large-font-style);
      letter-spacing: var(--cbar-sys-typescale-title-large-tracking);
      line-height: var(--cbar-sys-typescale-title-large-line-height);
      text-transform: var(--cbar-sys-typescale-title-large-text-transform);
      text-decoration: var(--cbar-sys-typescale-title-large-text-decoration);
    }
    /* Headline Small */
    .headline-small {
      font-family: var(--cbar-sys-typescale-headline-small-font);
      font-weight: var(--cbar-sys-typescale-headline-small-weight);
      font-size: var(--cbar-sys-typescale-headline-small-size);
      font-style: var(--cbar-sys-typescale-headline-small-font-style);
      letter-spacing: var(--cbar-sys-typescale-headline-small-tracking);
      line-height: var(--cbar-sys-typescale-headline-small-line-height);
      text-transform: var(--cbar-sys-typescale-headline-small-text-transform);
      text-decoration: var(--cbar-sys-typescale-headline-small-text-decoration);
    }
    /* Headline Medium */
    .headline-medium {
      font-family: var(--cbar-sys-typescale-headline-medium-font);
      font-weight: var(--cbar-sys-typescale-headline-medium-weight);
      font-size: var(--cbar-sys-typescale-headline-medium-size);
      font-style: var(--cbar-sys-typescale-headline-medium-font-style);
      letter-spacing: var(--cbar-sys-typescale-headline-medium-tracking);
      line-height: var(--cbar-sys-typescale-headline-medium-line-height);
      text-transform: var(--cbar-sys-typescale-headline-medium-text-transform);
      text-decoration: var(--cbar-sys-typescale-headline-medium-text-decoration);
    }
    /* Headline Large */
    .headline-large {
      font-family: var(--cbar-sys-typescale-headline-large-font);
      font-weight: var(--cbar-sys-typescale-headline-large-weight);
      font-size: var(--cbar-sys-typescale-headline-large-size);
      font-style: var(--cbar-sys-typescale-headline-large-font-style);
      letter-spacing: var(--cbar-sys-typescale-headline-large-tracking);
      line-height: var(--cbar-sys-typescale-headline-large-line-height);
      text-transform: var(--cbar-sys-typescale-headline-large-text-transform);
      text-decoration: var(--cbar-sys-typescale-headline-large-text-decoration);
    }
    /* Display Small */
    .display-small {
      font-family: var(--cbar-sys-typescale-display-small-font);
      font-weight: var(--cbar-sys-typescale-display-small-weight);
      font-size: var(--cbar-sys-typescale-display-small-size);
      font-style: var(--cbar-sys-typescale-display-small-font-style);
      letter-spacing: var(--cbar-sys-typescale-display-small-tracking);
      line-height: var(--cbar-sys-typescale-display-small-line-height);
      text-transform: var(--cbar-sys-typescale-display-small-text-transform);
      text-decoration: var(--cbar-sys-typescale-display-small-text-decoration);
    }
    /* Display Medium */
    .display-medium {
      font-family: var(--cbar-sys-typescale-display-medium-font);
      font-weight: var(--cbar-sys-typescale-display-medium-weight);
      font-size: var(--cbar-sys-typescale-display-medium-size);
      font-style: var(--cbar-sys-typescale-display-medium-font-style);
      letter-spacing: var(--cbar-sys-typescale-display-medium-tracking);
      line-height: var(--cbar-sys-typescale-display-medium-line-height);
      text-transform: var(--cbar-sys-typescale-display-medium-text-transform);
      text-decoration: var(--cbar-sys-typescale-display-medium-text-decoration);
    }
    /* Display Large */
    .display-large {
      font-family: var(--cbar-sys-typescale-display-large-font);
      font-weight: var(--cbar-sys-typescale-display-large-weight);
      font-size: var(--cbar-sys-typescale-display-large-size);
      font-style: var(--cbar-sys-typescale-display-large-font-style);
      letter-spacing: var(--cbar-sys-typescale-display-large-tracking);
      line-height: var(--cbar-sys-typescale-display-large-line-height);
      text-transform: var(--cbar-sys-typescale-display-large-text-transform);
      text-decoration: var(--cbar-sys-typescale-display-large-text-decoration);
    }
`;
